const elementId = {
  feed: "feed-container",
  footer: "site-footer",
  main: "main-container",
  react: "react-application",
  splash: "splash-container",
};

module.exports = elementId;
